// FICTITIOUS demo data. Replace with a flight API later (see services/offers.js).
// Cabin feature status: "yes" | "no" | "unknown", each with its source.
const SRC_API = "données du vol (exemple)";
const SRC_AIRLINE = "plan de cabine de la compagnie (exemple)";
const cab = (aircraft, flatBed, aisle, door) => ({
  aircraft,
  aircraftSource: aircraft === "Modèle inconnu" ? "aucune source disponible" : SRC_API,
  flatBed: { status: flatBed, source: flatBed === "unknown" ? null : SRC_API },
  aisle: { status: aisle, source: aisle === "unknown" ? null : SRC_AIRLINE },
  door: { status: door, source: door === "unknown" ? null : SRC_AIRLINE },
});

export const DEMO_OFFERS = [
  {
    id: "cdg-mia",
    origin: "CDG",
    originCity: "Paris",
    city: "Miami",
    country: "États-Unis",
    code: "MIA",
    image: "/images/miami.jpg",
    price: "1 890 €",
    saving: 0.22,
    airline: "Compagnie aérienne A (exemple)",
    stops: "Vol direct",
    duration: "≈ 10 h 15",
    dates: ["14 janv. → 24 janv. 2027", "02 févr. → 11 févr. 2027", "09 mars → 19 mars 2027"],
    cabin: cab("Gros-porteur, modèle d'exemple", "yes", "yes", "unknown"),
    home: true,
  },
  {
    id: "cdg-jfk",
    origin: "CDG",
    originCity: "Paris",
    city: "New York",
    country: "États-Unis",
    code: "JFK",
    image: "/images/new-york.jpg",
    price: "1 740 €",
    saving: 0.25,
    airline: "Compagnie aérienne B (exemple)",
    stops: "Vol direct",
    duration: "≈ 9 h 10",
    dates: ["21 janv. → 28 janv. 2027", "15 févr. → 22 févr. 2027"],
    cabin: cab("Gros-porteur, modèle d'exemple", "yes", "no", "no"),
    home: true,
  },
  {
    id: "cdg-bkk",
    origin: "CDG",
    originCity: "Paris",
    city: "Bangkok",
    country: "Thaïlande",
    code: "BKK",
    image: "/images/bangkok.jpg",
    price: "2 150 €",
    saving: 0.3,
    airline: "Compagnie aérienne C (exemple)",
    stops: "1 escale à Doha (DOH)",
    duration: "≈ 15 h 20",
    dates: ["05 févr. → 19 févr. 2027", "12 mars → 26 mars 2027"],
    cabin: cab("Gros-porteur, modèle d'exemple", "yes", "yes", "yes"),
    home: true,
  },
  {
    id: "cdg-dxb",
    origin: "CDG",
    originCity: "Paris",
    city: "Dubaï",
    country: "Émirats arabes unis",
    code: "DXB",
    image: "/images/dubai.jpg",
    price: "1 590 €",
    saving: 0.21,
    airline: "Compagnie aérienne D (exemple)",
    stops: "Vol direct",
    duration: "≈ 6 h 30",
    dates: ["10 janv. → 17 janv. 2027", "07 févr. → 14 févr. 2027", "04 avr. → 11 avr. 2027"],
    cabin: cab("Gros-porteur, modèle d'exemple", "yes", "unknown", "unknown"),
    home: true,
  },
  {
    id: "cdg-dps",
    origin: "CDG",
    originCity: "Paris",
    city: "Bali",
    country: "Indonésie",
    code: "DPS",
    image: "/images/bali.jpg",
    price: "2 480 €",
    airline: "Compagnie aérienne F (exemple)",
    stops: "1 escale à Singapour (SIN)",
    duration: "≈ 18 h 30",
    dates: ["18 févr. → 04 mars 2027", "22 avr. → 06 mai 2027"],
    cabin: cab("Modèle inconnu", "unknown", "unknown", "unknown"),
    home: false,
  },
  {
    id: "cdg-cun",
    origin: "CDG",
    originCity: "Paris",
    city: "Cancún",
    country: "Mexique",
    code: "CUN",
    image: "/images/cancun.jpg",
    price: "1 980 €",
    saving: 0.28,
    airline: "Compagnie aérienne G (exemple)",
    stops: "1 escale à Francfort (FRA)",
    duration: "≈ 14 h 45",
    dates: ["15 avr. → 21 avr. 2027", "14 déc. → 23 déc. 2026"],
    cabin: cab("Gros-porteur, modèle d'exemple", "yes", "yes", "unknown"),
    home: true,
  },
  {
    id: "cdg-gig",
    origin: "CDG",
    originCity: "Paris",
    city: "Rio de Janeiro",
    country: "Brésil",
    code: "GIG",
    image: "/images/rio.jpg",
    price: "2 070 €",
    saving: 0.2,
    airline: "Compagnie aérienne H (exemple)",
    stops: "1 escale à São Paulo (GRU)",
    duration: "≈ 16 h 55",
    dates: ["19 nov. → 25 nov. 2026", "03 déc. → 09 déc. 2026"],
    cabin: cab("Gros-porteur, modèle d'exemple", "yes", "yes", "no"),
    home: true,
  },
  {
    id: "cdg-mex",
    origin: "CDG",
    originCity: "Paris",
    city: "Mexico",
    country: "Mexique",
    code: "MEX",
    image: "/images/mexico.jpg",
    price: "1 860 €",
    saving: 0.27,
    airline: "Compagnie aérienne I (exemple)",
    stops: "Vol direct",
    duration: "≈ 12 h 05",
    dates: ["08 janv. → 17 janv. 2027", "11 mars → 20 mars 2027"],
    cabin: cab("Gros-porteur, modèle d'exemple", "yes", "yes", "unknown"),
    home: true,
  },
  {
    id: "cdg-hnd",
    origin: "CDG",
    originCity: "Paris",
    city: "Tokyo",
    country: "Japon",
    code: "HND",
    image: "/images/tokyo.jpg",
    price: "2 260 €",
    saving: 0.23,
    airline: "Compagnie aérienne J (exemple)",
    stops: "Vol direct",
    duration: "≈ 14 h 15",
    dates: ["04 févr. → 13 févr. 2027", "01 avr. → 10 avr. 2027"],
    cabin: cab("Gros-porteur, modèle d'exemple", "yes", "yes", "yes"),
    home: true,
  },
];
